import { render, staticRenderFns } from "./ListGroupBasic.vue?vue&type=template&id=056822f2"
import script from "./ListGroupBasic.vue?vue&type=script&lang=js"
export * from "./ListGroupBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports